// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#tp editable-display div.content{margin-top:2rem}`, "",{"version":3,"sources":["webpack://./client/app/common/editableDisplay/editableDisplay.scss"],"names":[],"mappings":"AAGE,iCACE,eAAA","sourcesContent":["@import '../variables.scss';\n\n#tp editable-display {\n  div.content {\n    margin-top: 2rem;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
